import React from 'react';

import './InputCurrencyField.scss';

class InputCurrencyField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
    }
  }

  componentDidMount() {
    const { value, validator } = this.props;

    this.valueInputRef = React.createRef();
    const convertedValue = this._convertValue(value);
    const isValid = validator ? validator(convertedValue) : true;

    this.setState({
      value: convertedValue,
      valueInputHasFocus: false,
      isValid,
    });
  }

  componentDidUpdate(prevProps) {
    const { validator, value } = this.props;

    if (value !== prevProps.value) {
      const convertedValue = this._convertValue(value);
      const isValid = validator ? validator(convertedValue) : true;

      this.setState({
        value: convertedValue,
        isValid,
      });
    }

    if (validator !== prevProps.validator) {
      const { value } = this.state;
      const isValid = validator ? validator(value) : true;

      this.setState({ isValid });
    }
  }

  _convertValue(value) {
    const precision = this.getDefaultPrecisionForValue(value);
    const modifiedValue = (value === null) ?
      '' :
      (Number(value / 100).toPrecision(precision));
    return modifiedValue;
  }

  handleChange = value => {
    const { validator } = this.props;

    const isValid = validator ? validator(value) : true;
    this.setState({ value, isValid });
  }

  handleInputBlur = () => {
    const { onChange } = this.props;
    const { isValid } = this.state;

    const value = (this.state.value === '') ?
      null :
      Math.round(Number(this.state.value) * 100);

    onChange(value, isValid);
    this.setState({ valueInputHasFocus: false });
  }

  handleContainerClick = () => {
    if (this.props.editMode && this.valueInputRef.current) {
      this.valueInputRef.current.focus();
    }
  }

  getDefaultPrecisionForValue(value) {
    return String(value).replace(/^\-+/g, '').length;
  }

  render() {
    const {
      inputId,
      editMode,
      disabledMode,
      negativeMode = (this.state.value < 0),
      dashForNull = false,
      validatorText,
      specialCharCheck,
    } = this.props;

    const { value, isValid } = this.state;

    const containerClasses = ['parkchirp--input-currency-field'];
    if (editMode) containerClasses.push('edit');
    if (disabledMode) containerClasses.push('disabled');
    if (negativeMode) containerClasses.push('negative');
    if (this.state.valueInputHasFocus) containerClasses.push('focus');

    const dashMode = dashForNull && (value === null || value === '');

    return (
      <>
        <div
          className={containerClasses.join(' ')}
          onClick={this.handleContainerClick}>
          {(editMode) &&
            <React.Fragment>
              <span className="parkchirp--input-currency-field--unit">$</span>
              <input
                ref={this.valueInputRef}
                type="number"
                id={inputId}
                value={value}
                onKeyDown={e => !specialCharCheck ? ['e','E'].includes(e.key) : ['e','E','-'].includes(e.key) && e.preventDefault()}
                onChange={event => this.handleChange(event.target.value)}
                onFocus={() => this.setState({ valueInputHasFocus: true })}
                onBlur={this.handleInputBlur}
                disabled={disabledMode}
              />
            </React.Fragment>
          }
          {(!editMode && !isNaN(this.props.value)) &&
            <span>
              {(negativeMode) &&
                <span className="parkchirp--input-currency-field--negative-value-wrapper">(</span>
              }
              {(!dashMode) && <span className="parkchirp--input-currency-field--unit">$</span> }
              {(!dashMode) && value.replace(/^\-+/g, '')}
              {(dashMode) && <span>-</span>}
              {(negativeMode) &&
                <span className="parkchirp--input-currency-field--negative-value-wrapper">)</span>
              }
            </span>
          }
        </div>
        {!isValid && (validatorText ?? '')}
      </>
    );
  }
};

export default InputCurrencyField;
